import axios from 'axios';

let BACKEND_URL = '';

const fetchConfig = async () => {
  if (!BACKEND_URL) {
    if (process.env.NODE_ENV === 'production') {
      try {
        const response = await axios.get('/config');

        BACKEND_URL = response.data.BACKEND_URL; // Store it globally
      } catch (error) {
        console.error('Failed to load config:', error);
      }
    } else {
      // when testing locally
      BACKEND_URL = process.env.REACT_APP_BACK_URL;
    }
  }
};

export async function getOneNote(noteId) {
  try {
    await fetchConfig();
    const completeUrl = `${BACKEND_URL}/v3/notes/${noteId}`;
    console.log(
      'BC process.env.REACT_APP_BACK_URL: ',
      process.env.REACT_APP_BACK_URL
    );
    console.log('BC process.env.NODE_ENV: ', process.env.NODE_ENV);
    console.log('BC completeUrl: ', completeUrl);
    const response = await axios.get(completeUrl);

    const str = response.data.htm;

    return str;
  } catch (error) {
    console.log('BC error: ', error);

    throw error;
  }
}
